import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { clearStorage } from 'features/auth';
import { UserApiService } from 'features/users';
import { queryClient } from 'providers';
import { User } from 'types';

import { userQueryKeys } from './query-keys';
const { getUser } = UserApiService();
const getUserQuery = (
  id: string,
  options?: UseQueryOptions<User>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<User>;
  options?: UseQueryOptions<User>;
} => ({ 
  queryKey: userQueryKeys.detail(id),
  queryFn: async ({ signal }) => {
    const response = await getUser(id, { config: { signal } });
      
    if (response.rs === 200 && response.res) {
      return response.res;
    } else {
      clearStorage();
      queryClient.clear();
      throw new Error(`Unexpected response status: ${response.rs}`);
    }
  },
  ...options,
});

export const useGetUser = (id: string, options?: UseQueryOptions<User>) => {
  const { message } = App.useApp();

  return useQuery<User, Error>(
    getUserQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};










